import { i18nKeys } from '../../../app.i18n'

import { CoreValueOption } from './rating-value'

const CoreValueTypeToClassNameMap: { [key: number]: string } = {
  [CoreValueOption.BeEntepreneurial]: 'allstars__tag--enterpreneurial',
  [CoreValueOption.BeFocused]: 'allstars__tag--results',
  [CoreValueOption.BeInnovative]: 'allstars__tag--innovative',
  [CoreValueOption.BeFair]: 'allstars__tag--fair',
}

const CoreValueToTagTitleMap: { [key: number]: any } = {
  [CoreValueOption.BeEntepreneurial]: i18nKeys.frontFace.allstars.coreValueTag.entepreneurial,
  [CoreValueOption.BeFocused]: i18nKeys.frontFace.allstars.coreValueTag.focused,
  [CoreValueOption.BeInnovative]: i18nKeys.frontFace.allstars.coreValueTag.innovative,
  [CoreValueOption.BeFair]: i18nKeys.frontFace.allstars.coreValueTag.fair,
}

export const CoreValueToClassName = (coreValueNumber: number) => {
  return CoreValueTypeToClassNameMap[coreValueNumber]
}

export const CoreValueToTitle = (coreValueNumber: number) => {
  return CoreValueToTagTitleMap[coreValueNumber]
}



// WEBPACK FOOTER //
// ./src/app/front-face/shared/review/core-value.ts